import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-direccion-antecedentes-laborales',
  templateUrl: './direccion-antecedentes-laborales.component.html',
  styleUrls: ['./direccion-antecedentes-laborales.component.scss'],
})
export class DireccionAntecedentesLaboralesComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      calle: [values ? values.calle : '', [Validators.required]],
      casa_edificio: [
        values ? values.casa_edificio : '',
        [Validators.required],
      ],
      avenida: [values ? values.avenida : '', [Validators.required]],
      piso_apartamento: [
        values ? values.piso_apartamento : '',
        [Validators.required, Validators.pattern(/^[0-9]\d*$/)],
      ],
      urbanizacion: [values ? values.urbanizacion : '', [Validators.required]],
      parroquia: [values ? values.parroquia : '', [Validators.required]],
      municipio: [values ? values.municipio : '', [Validators.required]],
      ciudad: [values ? values.ciudad : '', [Validators.required]],
      estado: [values ? values.estado : '', [Validators.required]],
      referencia_direccion: [
        values ? values.referencia_direccion : '',
        [Validators.required],
      ],
      nombre_empresa: [
        values ? values.nombre_empresa : '',
        [Validators.required],
      ],
      rif: [
        values ? values.rif : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
